import { useEffect } from "react";
import { useNavigate } from "../lib/nav";

import { Icon, Menu } from "@omnabase/ui";
import { useSession } from "./store";
import { roleWord } from "./words";
import { Mark } from "./Mark";

/** Where you are: the workspace's mark (its logo when it has one, 2026-10-20) at the top of the rail (or a row at the top of More on a phone) opens the switcher: the
 *  workspaces you belong to with your role and ⌘1…⌘9, the workspace's settings, and a way to a new one. Ported from the prototype. */
export function WorkspaceSwitcher({ phone }: { phone?: boolean }) {
  const { me, workspace } = useSession();
  const navigate = useNavigate();
  const list = me.workspaces;
  useEffect(() => {
    if (phone) return;
    const onKey = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey || !/^[1-9]$/.test(e.key)) return;
      const el = e.target as HTMLElement | null; if (el?.closest?.("input, textarea, [contenteditable]")) return;
      const w = list[Number(e.key) - 1]; if (!w) return;
      e.preventDefault(); navigate(`/${w.slug}`);
    };
    window.addEventListener("keydown", onKey); return () => window.removeEventListener("keydown", onKey);
  }, [phone, list, navigate]);
  const sections = [
    { label: "Workspaces", items: list.map((w, i) => ({ id: w.id, label: w.name, checked: w.id === workspace.id, meta: `${roleWord(w.role)} · ⌘${i + 1}`, onSelect: () => navigate(`/${w.slug}`) })) },
    { items: [
      { id: "settings", label: "Workspace settings", icon: "settings" as const, onSelect: () => navigate(`/${workspace.slug}/settings/general`) },
      { id: "add", label: "Add a workspace", icon: "plus" as const, onSelect: () => navigate("/signin?step=new") },
    ] },
  ];
  const trigger = phone
    ? <button type="button" className="ob-more__workspace" aria-label={`Workspace: ${workspace.name}`}><Mark mark={workspace.mark} logo={workspace.logo} /><span className="ob-more__workspace-text"><strong>{workspace.name}</strong><span>app.omnabase.com/{workspace.slug} · {roleWord(workspace.me.role)}</span></span><Icon name="chevronDown" size="sm" /></button>
    : <button type="button" className={`ob-rail__mark${workspace.logo ? " ob-rail__mark--logo" : ""}`} aria-label={`Workspace: ${workspace.name}`} title={`${workspace.name} · switch workspace`}>{workspace.logo ? <img className="ob-mark__img" src={workspace.logo} alt="" /> : workspace.mark}</button>; // 2026-10-20: the logo in the mark's square
  return <Menu align="start" trigger={trigger} sections={sections} />;
}
